import { DataRouteDefinition } from "routes/data-routes/types";
import { PricingOptions } from "types/billing/pricing-options/PricingOptions";


export const PricingOptionsDataRoutePath = "/data-routes/billing-data/pricing-options";

export type PricingOptionsDataRouteType = Required<DataRouteDefinition<PricingOptions, "pricingOptions", typeof PricingOptionsDataRoutePath>>;
